import React from "react";
import { graphql } from "gatsby";
import { motion } from "framer-motion";
import { FADE_UP, useInView } from "../animationUtils";

export const fragments = graphql`
  fragment Page_LogosNoBackground on PrismicPageDataBodyLogosNoBackground {
    items {
      logo_stripe {
        url
      }
    }
  }
  fragment FocusArea_LogosNoBackground on PrismicFocusAreaDataBodyLogosNoBackground {
    items {
      logo_stripe {
        url
      }
    }
  }
  fragment Project_LogosNoBackground on PrismicProjectDataBodyLogosNoBackground {
    items {
      logo_stripe {
        url
      }
    }
  }
  fragment Homepage_LogosNoBackground on PrismicHomepageDataBodyLogosNoBackground {
    items {
      logo_stripe {
        url
      }
    }
  }
`;

function LogosNoBackground({ data }) {
  const { items } = data;
  const [refImage, inViewImage] = useInView();
  return (
    <div className="logos-no-background">
      <motion.div
        ref={refImage}
        {...FADE_UP}
        animate={inViewImage ? "start" : ""}
        className="logos-no-background__content"
      >

        {items?.map((logo, idx) => {
          if (!logo?.logo_stripe?.url) return null;
          return (
            <div
              key={idx}
              className="logos-no-background__logo"
              style={{ backgroundImage: `url(${logo?.logo_stripe?.url})` }}
            ></div>
          );
        })}

      </motion.div>

    </div>
  );
}

export default LogosNoBackground;
